/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import { Container, Grid, Menu as BaseMenu } from 'semantic-ui-react';

import { Divider, PageHeader } from '../../../components';
import SeminarsList from '../containers/SeminarsList';
import AddSeminarButton from './AddSeminarButton';
import Search from '../containers/Search';

const intlMessages = {
    search: defineMessages({
        placeholder: {
            id: 'pages.seminars.SeminarPage.search.placeholder',
            defaultMessage: 'Search...',
        },
    }),
};

const Menu = styled(BaseMenu)`
    &.menu {
        margin: -0.5em -1em !important;
    }
`;

const SeminarPage = ({ intl }) => (
    <Container fluid>
        <Menu secondary>
            <BaseMenu.Item header>
                <PageHeader>
                    <FormattedMessage
                        id="pages.seminars.SeminarPage.seminar.label"
                        defaultMessage="Seminar"
                    />
                </PageHeader>
            </BaseMenu.Item>
            <BaseMenu.Menu position="right">
                <BaseMenu.Item fitted>
                    <Search
                        placeholder={intl.formatMessage(
                            intlMessages.search.placeholder,
                        )}
                    />
                </BaseMenu.Item>
                <BaseMenu.Item>
                    <AddSeminarButton />
                </BaseMenu.Item>
            </BaseMenu.Menu>
        </Menu>
        <Divider />
        <Grid columns={1}>
            <Grid.Column>
                <SeminarsList />
            </Grid.Column>
        </Grid>
    </Container>
);

export default injectIntl(SeminarPage);
